import React from "react";
import AssignmentChip from "./AssignmentChip";
import {
  getOpenGaps,
  getSlotTemplateRange,
} from "../../../utils/scheduleTimeUtils";
import {
  isAmbulanceSlot,
  isFixedTwoPeople,
  isTentSlot,
} from "../../../utils/scheduleRoleUtils";

export default function SlotCard({
  iso,
  roleKey,
  roleLabel,
  displayLabel,
  assignments,
  blocked,
  readOnly,
  employeeById,
  dragOver,
  unitText,
  onUnitTextChange,
  onCardClick,
  onPublishedShiftClick,
  onEditAssignment,
  onToggleBlocked,
  onRemoveExtra,
  onAddExtraTentSlot,
  onAddInsideCardSlot,
  isExtraSlot,
  onDropAssignment,
  onDropAssignmentOnCard,
  onDragStart,
  onDragEnd,
  onDragEnter,
  onDragLeave,
  publishedShifts = [],
}) {
  const template = getSlotTemplateRange(roleLabel);
  const openGaps = getOpenGaps(assignments, template.start, template.end, roleLabel);
  const canAdd = !blocked && !isAmbulanceSlot(roleLabel) && openGaps.length > 0;
  const hasPublished = publishedShifts.length > 0;

  return (
    <div
      className="schedule-slot-card"
      onClick={() => !readOnly && canAdd && onCardClick()}
      onDragOver={(e) => {
        if (readOnly || blocked || isAmbulanceSlot(roleLabel)) return;
        e.preventDefault();
      }}
      onDrop={(e) => {
        if (readOnly || blocked || isAmbulanceSlot(roleLabel)) return;
        e.preventDefault();
        onDropAssignment(e);
      }}
      onDragEnter={() => !readOnly && !blocked && !isAmbulanceSlot(roleLabel) && onDragEnter()}
      onDragLeave={() => !readOnly && !blocked && !isAmbulanceSlot(roleLabel) && onDragLeave()}
      style={{
        border: dragOver ? "2px solid #2563eb" : "1px solid #d8e1ec",
        borderRadius: 10,
        background: blocked ? "#f1f5f9" : hasPublished ? "#f0fdf4" : "#ffffff",
        padding: 8,
        display: "grid",
        gap: 6,
        cursor: !readOnly && canAdd ? "pointer" : "default",
        opacity: blocked ? 0.8 : 1,
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr auto",
          gap: 8,
          alignItems: "start",
        }}
      >
        <div style={{ minWidth: 0 }}>
          <div style={{ fontWeight: 900, fontSize: 9, lineHeight: 1.1 }}>
            {displayLabel || roleLabel}
          </div>

          {hasPublished && (
            <div
              style={{
                marginTop: 4,
                display: "inline-block",
                fontSize: 10,
                fontWeight: 800,
                color: "#166534",
                background: "#dcfce7",
                border: "1px solid #86efac",
                borderRadius: 999,
                padding: "2px 6px",
              }}
            >
              Available
            </div>
          )}
        </div>

        <div
          style={{
            display: "grid",
            gap: 6,
            justifyItems: "center",
            alignContent: "start",
          }}
        >
          {!readOnly && !!onAddInsideCardSlot && !isAmbulanceSlot(roleLabel) && (
            <button
              type="button"
              className="btn btn-ghost"
              onClick={(e) => {
                e.stopPropagation();
                onAddInsideCardSlot();
              }}
              style={{
                fontSize: 9,
                padding: "4px 8px",
                minHeight: 28,
                lineHeight: 1.1,
                whiteSpace: "normal",
                textAlign: "center",
                width: 72,
              }}
            >
              + Add Slot
            </button>
          )}

          {!readOnly && !isExtraSlot && isTentSlot(roleLabel) && !!onAddExtraTentSlot && (
            <button
              type="button"
              className="btn btn-ghost"
              onClick={(e) => {
                e.stopPropagation();
                onAddExtraTentSlot();
              }}
              style={{
                fontSize: 9,
                padding: "4px 8px",
                minHeight: 28,
                lineHeight: 1.1,
                whiteSpace: "normal",
                textAlign: "center",
                width: 72,
              }}
            >
              + Tent Slot
            </button>
          )}

          {!readOnly && (
            <button
              type="button"
              className="btn btn-ghost"
              onClick={(e) => {
                e.stopPropagation();
                onToggleBlocked();
              }}
              style={{
                fontSize: 9,
                padding: "4px 8px",
                minHeight: 28,
                lineHeight: 1.1,
                width: 72,
              }}
            >
              {blocked ? "Unblock" : "Block"}
            </button>
          )}

          {!readOnly && isExtraSlot && (
            <button
              type="button"
              className="btn btn-ghost"
              onClick={(e) => {
                e.stopPropagation();
                onRemoveExtra();
              }}
              style={{
                fontSize: 10,
                padding: "4px 8px",
                minHeight: 28,
                lineHeight: 1.1,
                whiteSpace: "normal",
                textAlign: "center",
                width: 72,
              }}
            >
              Remove Slot
            </button>
          )}
        </div>
      </div>

      <div style={{ fontSize: 9, color: "#64748b", fontWeight: 700 }}>
        Shift: {template.start} - {template.end}
      </div>

      {blocked ? (
        <div
          style={{
            padding: 10,
            borderRadius: 10,
            background: "#e2e8f0",
            color: "#334155",
            fontWeight: 800,
            fontSize: 10,
          }}
        >
          Blocked for this day
        </div>
      ) : isAmbulanceSlot(roleLabel) ? (
        <div style={{ display: "grid", gap: 6 }}>
          <input
            type="text"
            value={unitText || ""}
            onChange={(e) => onUnitTextChange(e.target.value)}
            placeholder="Enter ambulance/unit name"
            disabled={readOnly}
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "100%",
              padding: "10px 12px",
              borderRadius: 10,
              border: "1px solid #cbd5e1",
              background: "#f8fafc",
              color: "#0f172a",
            }}
          />
        </div>
      ) : (
        <>
          {assignments.length > 0 && (
  <div style={{ display: "grid", gap: 6 }}>
    {assignments.map((a) => {
      const emp = employeeById.get(a.employeeId);

      return (
        <AssignmentChip
          key={a.assignmentId}
          assignment={a}
          employee={emp}
          onOpen={() => onEditAssignment(a)}
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
          onDragOver={(e) => {
            if (readOnly || !onDropAssignmentOnCard) return;
            e.preventDefault();
            e.stopPropagation();
          }}
          onDrop={(e) => {
            if (readOnly || !onDropAssignmentOnCard) return;
            e.preventDefault();
            e.stopPropagation();

            const rect = e.currentTarget.getBoundingClientRect();
            const midpoint = rect.top + rect.height / 2;
            const placement = e.clientY < midpoint ? "before" : "after";

            onDropAssignmentOnCard(e, a.assignmentId, placement);
          }}
        />
      );
    })}
  </div>
)}

          {!blocked && publishedShifts.length > 0 && (
            <div style={{ display: "grid", gap: 4 }}>
              {publishedShifts.map((s) => (
                <button
                  key={s.id}
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!readOnly) onPublishedShiftClick(s);
                  }}
                  style={{
                    fontSize: 11,
                    color: "#166534",
                    background: "#ecfdf5",
                    border: "1px solid #bbf7d0",
                    borderRadius: 8,
                    padding: "6px 8px",
                    fontWeight: 700,
                    textAlign: "left",
                    cursor: readOnly ? "default" : "pointer",
                  }}
                >
                  Available: {s.position || s.roleLabel} • {s.start}-{s.end}
                </button>
              ))}
            </div>
          )}
        </>
      )}

      {!blocked && !isAmbulanceSlot(roleLabel) && isFixedTwoPeople(roleLabel) && (
        <div style={{ fontSize: 11, color: "#64748b" }}>
          Filled: {assignments.length} of 2
        </div>
      )}

      <div style={{ display: "none" }}>{iso}::{roleKey}</div>
    </div>
  );
}